// extracted by mini-css-extract-plugin
module.exports = {"inputTittle":"FrameworkTitle_inputTittle__3Gg-3","editIcon":"FrameworkTitle_editIcon__3MPke"};